/**
 * How long something is, in words, for every screen that has to say so.
 *
 * Extracted from `Today.tsx`, where both of these were module-private, because the week canvas
 * says the same two things in seven column headers. A second copy of `spanLabel` would be a
 * second place for "2h 35m" to become "155m", and the budget bar and the column header above it
 * would then be describing the same Thursday in two different dialects.
 */

/** "14:30" from minutes since midnight — a clock time, for the drag preview and hour rows. */
export const minuteLabel = (minutes: number): string =>
  `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;

/**
 * A span of time as a person would say it: "2h 35m", "45m", "3h".
 *
 * Not `minuteLabel`, which reads as a clock — "02:35" in a sentence about how much work is left
 * is a time of day, and the budget bar sits directly under a screen full of them.
 */
export const spanLabel = (minutes: number): string => {
  const whole = Math.max(0, Math.round(minutes));
  const hours = Math.floor(whole / 60);
  const rest = whole % 60;
  if (hours === 0) return `${rest}m`;
  return rest === 0 ? `${hours}h` : `${hours}h ${rest}m`;
};
